import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { CheckCircle2, Loader2, XCircle, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Sidebar } from '../components/Sidebar';
import { TopBar } from '../components/TopBar';
// import { buildHistory } from '../data/mockData';
import { useEffect, useState } from 'react';
import API from '../lib/api';
import { useNavigate } from 'react-router-dom';

export const getBuilds = async (req, res) => {
    try {
        const userId = req.user.id;

        const [rows] = await pool.query(
            "SELECT * FROM builds WHERE user_id = ? ORDER BY id DESC",
            [userId]
        );

        res.json({ builds: rows });

    } catch (err) {
        console.error(err);
        res.status(500).json({ message: "Error fetching builds" });
    }
};

export default function Builds() {
  // const getStatusIcon = (status) => {
  //   switch (status) {
  //     case 'success':
  //       return <CheckCircle2 className="w-5 h-5 text-green-500" />;
  //     case 'in_progress':
  //       return <Loader2 className="w-5 h-5 text-accent animate-spin" />;
  //     case 'failed':
  //       return <XCircle className="w-5 h-5 text-red-500" />;
  //     default:
  //       return <Clock className="w-5 h-5 text-muted-foreground" />;
  //   }
  // };

  // const getStatusText = (status) => {
  //   switch (status) {
  //     case 'success':
  //       return 'Success';
  //     case 'in_progress':
  //       return 'In Progress';
  //     case 'failed':
  //       return 'Failed';
  //     default:
  //       return 'Pending';
  //   }
  // };

  // const getStatusBadgeClass = (status) => {
  //   switch (status) {
  //     case 'success':
  //       return 'bg-green-500/10 text-green-500 border-green-500/20';
  //     case 'in_progress':
  //       return 'bg-accent/10 text-accent border-accent/20';
  //     case 'failed':
  //       return 'bg-red-500/10 text-red-500 border-red-500/20';
  //     default:
  //       return 'bg-white/5 text-muted-foreground border-white/10';
  //   }
  // };

  const [buildHistory, setBuildHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ FETCH BUILDS
  useEffect(() => {
    const fetchBuilds = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await API.get("/builds", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setBuildHistory(res.data.builds || []);
      } catch (err) {
        console.error("Error fetching builds:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBuilds();
  }, []);

  

  const getStatusIcon = (status) => {
    switch (status) {

      case 'completed':
        return (
          <CheckCircle2 className="w-5 h-5 text-green-500" />
        );

      case 'building':
        return (
          <Loader2 className="w-5 h-5 text-purple-500 animate-spin" />
        );

      case 'failed':
        return (
          <XCircle className="w-5 h-5 text-red-500" />
        );

      default:
        return (
          <Clock className="w-5 h-5 text-muted-foreground" />
        );
    }
  };

  const getStatusText = (status) => {
    switch (status) {

      case 'completed':
        return 'Completed';

      case 'building':
        return 'Building';

      case 'failed':
        return 'Failed';

      default:
        return 'Pending';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {

      case 'completed':
        return 'bg-green-500/10 text-green-500 border-green-500/20';

      case 'building':
        return 'bg-purple-500/10 text-purple-500 border-purple-500/20';

      case 'failed':
        return 'bg-red-500/10 text-red-500 border-red-500/20';

      default:
        return 'bg-white/5 text-muted-foreground border-white/10';
    }
  };

  // ✅ LOADING STATE
  if (loading) {
    return (
      <div className="text-white flex justify-center items-center h-screen">
        Loading builds...
      </div>
    );
  }


  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <Sidebar />
      
      <div className="md:ml-64">
        <TopBar />
        
        <main className="p-6 md:p-12 max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-8"
          >
            <div>
              <h1
                className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-2"
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
                data-testid="builds-title"
              >
                Build History
              </h1>
              <p className="text-lg text-muted-foreground">
                Track all your AI-generated applications
              </p>
            </div>

            <div className="space-y-4" data-testid="builds-list">
              {buildHistory.map((build, index) => (
                <motion.div
                  key={build.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="group p-6 rounded-2xl border border-white/5 bg-white/5 hover:bg-white/10 hover:border-primary/30 transition-all cursor-pointer"
                  data-testid={`build-item-${build.id}`} onClick={() => navigate(`/builds/${build.id}`)}
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-1 min-w-0 space-y-3">
                      <div className="flex items-start justify-between gap-4">
                        <p className="text-white font-medium text-lg leading-relaxed" data-testid={`build-prompt-${build.id}`}>
                          {build.prompt}
                        </p>
                        <div
                          className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-medium whitespace-nowrap ${getStatusBadgeClass(
                            build.status
                          )}`}
                          data-testid={`build-status-${build.id}`}
                        >
                          {getStatusIcon(build.status)}
                          {getStatusText(build.status)}
                        </div>
                      </div>

                      <div className="flex items-center gap-6 text-sm text-muted-foreground">
                        <span data-testid={`build-time-${build.id}`}>
                          {formatDistanceToNow(new Date(build.created_at), { addSuffix: true })}
                        </span>
                        <span className="flex items-center gap-2">
                          <Clock className="w-4 h-4" />
                          {build.duration}
                        </span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </main>
      </div>
    </div>
  );
}
